// Dictionnaire français = la langue source, assemblée par fragments.
// Chaque page/groupe de composants a son fragment (créé lors de sa
// traduction) ; l'objet final est plat : 'espace.cle' -> texte.
import common from './common';
import home from './home';
import experience from './experience';
import shop from './shop';
import fiche from './fiche';
import tunnel from './tunnel';
import regles from './regles';
import divers from './divers';

export default {
  ...common,
  ...home,
  ...experience,
  ...shop,
  ...fiche,
  ...tunnel,
  ...regles,
  ...divers,
};
